<template>
  <product-upsells
    v-if="product?.upsell"
    data-test-id="product-upsell"
    :title="$t.productUpsellTitle"
    :upsells="product.upsell"
    @open-quickshop="openQuickshop($event, gtmConfig)"
    @rec-click="handleRecClick"
  />
</template>

<script setup lang="ts">
import type { InteractionOrigin, ProductClickAction, ProductContext } from '#types/gtm'

const { $gtm } = useNuxtApp()
const { openQuickshop, product } = usePdp()

const gtmConfig: ProductContext & { appSource?: InteractionOrigin } = {
  appSource: 'up-sell-complete-the-look',
  category: 'UpSellCompleteTheLook',
  list: 'UpSellCompleteTheLook'
}

const handleRecClick = (id: string, action?: ProductClickAction) => {
  if (!product.value?.upsell) return
  const index = product.value.upsell.findIndex((upsell) => upsell.id === id) || 0
  const upsell = product.value.upsell[index]
  const position = index + 1
  $gtm.push('upsell.onUpsellClick', upsell, position, { action })
  setInteractionOrigin('up-sell-complete-the-look', true)
}
</script>
